<template>
  <div id="home" class="home-container">
    <Header />
    <Hero />
    <Features />
    <div class="section-tag" v-html="$config.home.reasons_to_use">
    </div>
    <ContentSection 
      :title="$config.home.section1.title"
      :description="$config.home.section1.description"
      :image="$config.home.section1.image"
    />
    <ContentSection 
      :title="$config.home.section2.title"
      :description="$config.home.section2.description"
      :image="$config.home.section2.image"
      :reverse="true"
    />
    <ContentSection 
      :title="$config.home.section3.title"
      :description="$config.home.section3.description"
      :image="$config.home.section3.image"
    />
    <ContentSection 
      :title="$config.home.section4.title"
      :description="$config.home.section4.description"
      :image="$config.home.section4.image"
      :reverse="true"
    />
    <TestimonialsSection />
    <Footer />
  </div>
</template>

<script>
import Header from './Header.vue'
import Hero from './Hero.vue'
import Features from './Features.vue'
import ContentSection from './ContentSection.vue'
import TestimonialsSection from './TestimonialsSection.vue'
import Footer from './Footer.vue'

export default {
  name: 'Home',
  components: {
    Header,
    Hero,
    Features,
    ContentSection,
    TestimonialsSection,
    Footer
  }
}
</script>

<style scoped>
.home-container {
  position: relative;
}

.section-tag {
  width: 100%;
  text-align: center;
  color: #003c43; /* 根据图片调整颜色 */
  font-size: 1.8rem; /* 根据图片调整字体大小 */
  font-weight: normal; /* 默认不加粗 */
  margin-bottom: 24px;
  margin-top: 64px;
}

.section-tag strong {
  font-weight: bold; /* 只加粗 strong 标签内的文字 */
}

</style>